import { useTranslation } from "react-i18next";
import SearchResultItem from "./SearchResultItem";
import { LANGUAGE } from "services/general";

const GroupedResults = ({
  results,
  onViewAll,
  onItemClick,
  searchQuery = "",
}) => {
  const { t } = useTranslation();

  const categoryLabels = {
    customers: t("globalSearch.categories.customers"),
    entities: t("globalSearch.categories.entities"),
    invoices: t("globalSearch.categories.invoices"),
    projects: t("globalSearch.categories.projects"),
    properties: t("globalSearch.categories.properties"),
    units: t("globalSearch.categories.units"),
    vouchers: t("globalSearch.categories.vouchers"),
    lead_contacts: t("globalSearch.categories.leadContacts"),
    contracts: t("globalSearch.categories.contracts"),
    products: t("globalSearch.categories.products"),
    support_center: t("globalSearch.categories.supportCenter"),
    unit_messages: t("globalSearch.categories.unitMessages"),
  };

  const getCategoryCount = (category) => {
    return results[category]?.length || 0;
  };

  const getCategoryItems = (category, limit = 2) => {
    return results[category]?.slice(0, limit) || [];
  };

  const categories = Object.keys(categoryLabels).filter(
    (cat) => getCategoryCount(cat) > 0
  );

  if (categories.length === 0) {
    return (
      <div className="py-8 text-center text-text-muted">
        {t("globalSearch.noResults")}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {categories.map((category, index) => {
        const items = getCategoryItems(category, 2);
        const totalCount = getCategoryCount(category);

        return (
          <div key={category} className="min-w-0">
            {index > 0 && (
              <div className="border-t border-[#EDEDED] mb-6"></div>
            )}
            <div className="space-y-3 min-w-0">
              <div className="flex items-center justify-between gap-2 min-w-0">
                <h3 className="text-[#2F2D38] text-base font-semibold flex items-center gap-2 min-w-0 truncate">
                  {categoryLabels[category]}{" "}
                  <span className="bg-[#F8F8F8] text-[#A3A5B4] px-2 py-0.5 rounded-full text-xs font-normal shrink-0">
                    {totalCount}
                  </span>
                </h3>
                <button
                  onClick={() => onViewAll(category)}
                  className="text-brand text-sm font-medium hover:underline flex items-center gap-1 shrink-0"
                >
                  {t("globalSearch.viewAllResults")}
                  <span className="text-brand">
                    {LANGUAGE === "ar" ? "←" : "→"}
                  </span>
                </button>
              </div>
              <div className="space-y-1 min-w-0">
                {items.map((item) => (
                  <SearchResultItem
                    key={item.id}
                    item={item}
                    category={category}
                    onClick={onItemClick}
                    searchQuery={searchQuery}
                  />
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GroupedResults;
